import { type FocusEvent } from 'react';
import { Controller, type Control } from 'react-hook-form';

import { useTranslate, type CardOptionType } from 'hooks';
import type { PaymentType } from 'types';

import type { InputTypePropTypes } from '../input-type';

import type { InputPropTypes, CardFieldsType } from './type';

type Props = {
  control: Control<CardFieldsType, any>;
  selectedCard: CardOptionType;
  paymentData: PaymentType;
  amount: string;
  onHandleFocus: (e: FocusEvent<HTMLInputElement>) => void;
  InputComponent: React.ForwardRefExoticComponent<
    InputPropTypes & InputTypePropTypes & React.RefAttributes<HTMLInputElement>
  >;
};

const CvvInput = ({
  control,
  selectedCard,
  paymentData,
  amount,
  onHandleFocus,
  InputComponent,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Controller
      name="cvv"
      control={control}
      rules={
        selectedCard.newCard
          ? {
              required: true,
              pattern: {
                value: /^\d{3,4}$/,
                message: t('wrong_cvv'),
              },
            }
          : undefined
      }
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <InputComponent
          name="cvv"
          mask=""
          placeholder="CVC"
          format={selectedCard.newCard ? '###' : '***'}
          inputClassName={
            value ? 'w-[92px] md:w-[134px] text-center' : 'w-[72px] md:w-[116px] text-center'
          }
          value={value}
          onChange={onChange}
          onFocus={onHandleFocus}
          ref={ref}
          info={selectedCard.newCard ? t('1xbet.form-bank-card.input.cvv.tooltip') : undefined}
          showPass
          allowEmptyFormatting={!selectedCard.newCard}
          type={selectedCard.newCard ? 'password' : 'tel'}
          error={error?.message}
          disabled={paymentData.commission > amount || !selectedCard.newCard}
        />
      )}
    />
  );
};

export { CvvInput };
